import { createApiSlice } from "@common";
import { CRUD_LMS_HOLIDAYS_CONFIG, CRUD_LMS_SITE_CONFIG } from "@routes";

const apiConfig = [
  {
    name: "addHolidays",
    method: "post",
    url: CRUD_LMS_HOLIDAYS_CONFIG,
    stateKey: "message"
  },
  
  {
    name: "getHolidaysById",
    method: "get",
    url: CRUD_LMS_HOLIDAYS_CONFIG,
    stateKey: "data"
  },
   {
    name: "getSiteHolidays",
    method: "get",
    url:  CRUD_LMS_SITE_CONFIG,
    stateKey: "siteData"
  },
  {
    name: "updateHolidays",
    method: "put",
    url: CRUD_LMS_HOLIDAYS_CONFIG,
    stateKey: "message"
  },
  {
    name: "deleteHolidays",
    method: "delete",
    url: CRUD_LMS_HOLIDAYS_CONFIG,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    siteData:[],
    additionalData: []
  },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "Holiday",
  apiConfig,
  customReducers
);
const HolidaySlice = slice;

export default HolidaySlice.reducer;

export const {
  addHolidays,
  getHolidays,
 getHolidaysById,
  getSiteHolidays,
  updateHolidays,
  deleteHolidays
} = thunks;
export const { rowSelect } = actions;
